import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

import { IdArray } from '../edit-table/types';

interface SelectedPositionProviderState {
  selectedPositions?: unknown[];
  selectedPositionIds?: IdArray;
  setSelectedPositions?: (input: unknown[]) => void;
  setSelectedPositionIds?: (input: IdArray) => void;
}

const SelectedPositionContext =
  createContext<SelectedPositionProviderState>(null);

export const useSelectedPositionState = () => {
  const context = useContext(SelectedPositionContext);
  if (context === null)
    throw new Error(
      'useSelectedPosition must be used within a <SelectedPositionProvider>'
    );
  return context;
};

export const SelectedPositionProvider = (props: PropsWithChildren<unknown>) => {
  const [selectedPositions, setSelectedPositions] = useState<unknown[]>([]);
  const [selectedPositionIds, setSelectedPositionIdsInternal] =
    useState<IdArray>([]);

  const setSelectedPositionIds = useCallback((newIds: IdArray) => {
    if (Array.isArray(newIds)) setSelectedPositionIdsInternal(newIds);
  }, []);

  const value = useMemo(() => {
    return {
      selectedPositions,
      selectedPositionIds,
      setSelectedPositions,
      setSelectedPositionIds,
    };
  }, [selectedPositions, selectedPositionIds, setSelectedPositionIds]);

  return (
    <SelectedPositionContext.Provider value={value}>
      {props.children}
    </SelectedPositionContext.Provider>
  );
};
